<template>
  <b-form-group :label="$t(label)" class="input-label" v-b-tooltip.hover.right :title="$t(tooltip)">
    <b-form-input
      type="number"
      :number="true"
      @input="handleInput"
      :value="value"
      :state="isValid"
      :id="id"
      max="4"
    ></b-form-input>
  </b-form-group>
</template>

<script>
export default {


  props: {
    label: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {},
    id:{},
  },

  computed: {
    isValid() {
      if (this.required) {
        return this.value != null;
      } else {
        return null;
      }
    },
  },

  methods: {
    handleInput(value) {
      if (value < this.min) {
        value = this.min;
      }

      if (value > this.max) {
        value = this.max;
      }

      this.$emit("input", value);
    },
  },
};
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>